import { useAppSelector } from '@redux/hooks';
import { inboxUrl } from '@settings';
import RfqModal from '@tkmp/rfq/components/RfqModal/RfqModal';
import { buildUrl } from '@tkmp/rfq/components/ViewConversation/utils';
import ViewConversationLink from '@tkmp/rfq/components/ViewConversationLink';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import { isPostPrimary } from '@tkmp/rfq/utils';
import { CtaButton } from '@tkww/orion-web-ds-action';
import React, { useCallback, type FC } from 'react';
import type { SeasonType } from '../..';
import { useTrackPersonalizedQuoteCTA } from '../../hooks/useTrackPersonalizedQuoteCTA';
import Styles from './styles.scss';

interface PersonalizedQuoteCTAProps {
	selectedSeason?: SeasonType;
}

export const PersonalizedQuoteCTA: FC<PersonalizedQuoteCTAProps> = ({
	selectedSeason,
}) => {
	const track = useTrackPersonalizedQuoteCTA();
	const context = useInlineRfqForm({
		initiator: 'inline RFQ pricing top',
		headerText: 'Start the convo',
		buttonText: 'Send',
	});

	const vendorId = useAppSelector((state) => state.vendor.vendorRaw?.id ?? '');
	const conversations = useAppSelector(
		(state) => state.messagedVendors.conversations,
	);

	const handleClick = useCallback(() => {
		track(selectedSeason === 'off-peak' ? 'Off-peak season' : 'Peak season');
		context.openModal();
	}, [track, context, selectedSeason]);

	const shouldShowViewConversation = isPostPrimary(
		conversations,
		vendorId,
		context.isModalOpen,
		context.shouldShowErrors,
		context.areErrorsInForm,
	);

	if (shouldShowViewConversation) {
		return (
			<div className={Styles.viewConversationLink}>
				<ViewConversationLink
					href={buildUrl({ conversations, vendorId, inboxUrl })}
					isBlock={false}
				/>
			</div>
		);
	}

	return (
		<>
			<CtaButton
				styleType="secondary"
				size="lg"
				onClick={handleClick}
				className={Styles.personalizedQuoteCta}
				data-testid="personalized-quote-cta-button"
			>
				Get a personalized quote
			</CtaButton>
			<RfqModal context={context} />
		</>
	);
};
